import type {
  ComplexQuestion,
  ComplexQuestionInsert,
} from "@repo/app-types/entities/question";
import { Size } from "@repo/ui/helpers/helpers";
import { Textarea } from "@repo/ui/Inputs/textarea";
import { Label } from "@repo/ui/Label/label";
import type { FC } from "react";
import { MAX_CHARACTERS_PER_QUESTION } from "./basicQuestionEditor.js";
import { SurveyOptionsEditor } from "./surveyOptionsEditor.js";

interface MultipleChoiceQuestionEditorProps {
  question: ComplexQuestion | ComplexQuestionInsert;
  onChange: (question: ComplexQuestion | ComplexQuestionInsert) => void;
}

export const MultipleChoiceQuestionEditor: FC<
  MultipleChoiceQuestionEditorProps
> = ({ question, onChange }) => {
  return (
    <div>
      <div className="w-full">
        <Textarea
          label="Question"
          value={question.question}
          placeholder="Add your survey question..."
          onChange={(newValue) => {
            onChange({
              ...question,
              question: newValue,
            });
          }}
          shouldDisableNewline
          maxLength={MAX_CHARACTERS_PER_QUESTION}
        />
      </div>
      <div className="mt-2">
        <Label size={Size.SMALL}>Options</Label>
      </div>
      <SurveyOptionsEditor
        onOptionsChange={(options) => {
          onChange({
            ...question,
            options,
          });
        }}
        options={question.options}
      />
    </div>
  );
};
